@if (showRoleToggles()) {
  <zef-form-field class="__role-selector-form-field">
    <zef-form-label class="fx:pl-0-5">Primary Access</zef-form-label>

    <zui-toggle-button-group
      class="__toggle-button-group"
      [ngrxFormControlState]="roleCodeControl()">
      @for (option of availableRoles(); track option.value) {
        <zui-toggle-button
          class="__toggle-button"
          [value]="option.value"
          [disabled]="disabled()">
          <div class="__role-content">
            <div class="__role-label">{{ option.label }}</div>
            @if (option.description) {
              <div class="__role-description">{{ option.description }}</div>
            }
          </div>
        </zui-toggle-button>
      }
    </zui-toggle-button-group>
  </zef-form-field>

  <div class="__create-projects-spacer">
    @if (showCreateProjectsToggle()) {
      <div class="__create-projects-toggle">

        <zui-separator [size]="'mini'" [spacing]="'none'" class="__create-perm-toggle" />

        <div class="__create-projects-toggle_content">
          <mat-slide-toggle
            [ngrxFormControlState]="canCreateProjectsControl()"
            [disabled]="disabled()">
            Allow creating projects
          </mat-slide-toggle>
        </div>

      </div>
    }
  </div>
} @else if (showCreateProjectsToggle()) {
  <div class="__create-projects-toggle __create-projects-toggle--left">
    <div class="__create-projects-toggle_content">
      <mat-slide-toggle
        [ngrxFormControlState]="canCreateProjectsControl()"
        [disabled]="disabled()">
        Allow creating projects
      </mat-slide-toggle>
    </div>
  </div>
}
